import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { Subject, takeUntil } from 'rxjs';
import { RouterService } from '../../../services/router/router.service';
import { APP_ROUTES } from '../../../utils/route.constant';
import { IContractData } from '../../../interfaces/IJob';
import { SELECTED_CONTRACT_DATA } from '../../../utils/constants';
import { SPECIAL_MEMBER_OFFER_CONTENT } from './special-member-offer.config';
import { LIFERAY_WEB_CONSTANT } from '../../../utils/liferay.constant';
import { ICrossSellContent, ICrossSellContentLiferayResponse } from '../../../interfaces/ICrossSellContent';
import { LiferayService } from '../../../services/liferay/liferay.service';
import { UtilitiesService } from '../../../services/utilities/utilities.service';

import { Router } from '@angular/router';
import { CALL_BUTTON_CROSS_SELL_CE_LANDING_PAGE } from '../../../services/ga4/ga4.constant';
import { Ga4Service } from '../../../services/ga4/ga4.service';
import { IMessage } from '../../../services/messages/messages.interface';

@Component({
  selector: 'app-special-member-offer',
  templateUrl: './special-member-offer.component.html',
  styleUrl: './special-member-offer.component.scss'
})
export class SpecialMemberOfferComponent implements OnInit, OnDestroy {
  cleaner$ = new Subject<void>();
  contractData: IContractData | null = null;
  content = SPECIAL_MEMBER_OFFER_CONTENT;
  type = 'CE';
  contentToBeDisplayed: ICrossSellContent | null = null;
  isSpecialMemberOfferFormUrl = false;
  errorMessage: IMessage | null = null;
  constructor(
    private data: DataService,
    private routerService: RouterService,
    private liferay: LiferayService,
    private utils: UtilitiesService,
    private router: Router,
    private gaService: Ga4Service,
  ) { }

  ngOnInit(): void {
  // Check if current URL is /special-member-offer-form
    this.isSpecialMemberOfferFormUrl = this.router.url.startsWith('/special-member-offer-form');
    const stored = sessionStorage.getItem(SELECTED_CONTRACT_DATA);
    if (stored) {
      try {
        const parsed = JSON.parse(stored) as Partial<IContractData>;
        if (!parsed?.baseContract) {
          throw new Error('Invalid contract payload');
        }
        this.contractData = parsed as IContractData;
        this.data.contractData$.next(this.contractData);
      } catch {
        sessionStorage.removeItem(SELECTED_CONTRACT_DATA);
        this.routerService.goto(APP_ROUTES.DASHBOARD);
        return;
      }
    }
    this.data.contractData$
      .pipe(takeUntil(this.cleaner$))
      .subscribe({
        next: (contract) => {
          if (contract === null) {
            this.routerService.goto(APP_ROUTES.DASHBOARD);
            return;
          };
          this.contractData = contract;
          this.getCrossSellContent();
        }
      });

    this.data.messagesToDisplay$.pipe(takeUntil(this.cleaner$)).subscribe({
      next: (messages) => {
        if (messages && messages.length > 0) {
          this.errorMessage = messages.find(msg => msg.severity === 'error') || null;
        } else {
          this.errorMessage = null;
        }
      }
    });
  }

  getCrossSellContent(): void {
    const { type, id } = this.type === 'CE' ? LIFERAY_WEB_CONSTANT.cross_sell_ce_content : LIFERAY_WEB_CONSTANT.cross_sell_surge_content;
    this.liferay.getWebContent<ICrossSellContentLiferayResponse>(type, id)
      .pipe(takeUntil(this.cleaner$))
      .subscribe((webContent) => {
        if (!webContent) return;

        const contentToDisplayForClient = webContent.value?.content || [];
        const clientId = this.contractData?.baseContract?.clientId;
        const contentFound = contentToDisplayForClient.find(item => item.clientId === clientId) || null;
        this.contentToBeDisplayed = contentFound
          ? { ...contentFound, hoursOfOperation: this.utils.setHtmlContent(contentFound.hoursOfOperation || '') }
          : null;
      });
  }

  scrollToForm():void {
    const el = document.getElementById('special-member-offer-form');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  callPhone(phoneNumber: string): void {
    this.gaService.setGa4DtcSearsLanding(CALL_BUTTON_CROSS_SELL_CE_LANDING_PAGE, this.contractData?.baseContract?.clientId ?? 'Unknown Client');
    window.location.href = `tel:${phoneNumber}`;
  }

  clearErrorMessage(): void {
    this.errorMessage = null;
    this.data.messagesToDisplay$.next([]);
  }

  ngOnDestroy(): void {
    this.cleaner$.next();
    this.cleaner$.complete();
    sessionStorage.removeItem(SELECTED_CONTRACT_DATA);
  }
}
